import { PopperBase } from './popper-base';
import { LineCalendarCell, LineSelectedCell } from "../model";
import { PLANNER_CLICK_UNDER } from 'apps/events';
import PopperJS from 'popper.js';
import RiotEventManager from 'utilities/riot/event_manager';
import { PLANNER_CHANGE_UNDER, PLANNER_SUBMIT_UNDER } from 'apps/events';
import { FormUnder } from 'mixs/forms/orders/under';
class UpdateUnder extends PopperBase {
  eventManager: RiotEventManager;
  formElement: HTMLFormElement;
  init(){
    super.init();
    this.watchPlannerData('updateUnder', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeUpdateUnder(newVal, oldVal, objectPath)});
    this.eventManager = new RiotEventManager(this);
    this.eventManager.customEvent(PLANNER_CHANGE_UNDER, () => { this.onChangeUnder() });
  }
  onChangeUpdateUnder(newVal, oldVal, objectPath){
    if(newVal === null) {
      this.hide();
    } else {
      this.show(newVal);
    }
  }
  hide(){
    if(!this.isShow){ return; }
    this.isShow = false;
    this.update();
  }
  show(newVal){
    let newValue = { forms_orders_under: {
      action: '/orders/' + newVal.opts.id + '/update_under',
      inputs: { under: { value: newVal.opts.under } }
    }};
    App.store.dispatch(App.actions.data.update(newValue));
    this.dispatchNewValue(newVal);
    this.isShow = true;
    let popper = new PopperJS(
      newVal.element,
      this.querySelector('.popper'),
      this.getPopperOptions()
    );
    this.update();
  }
  onClose(){
    // let e = new CustomEvent(PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE, {});
    // document.dispatchEvent(e);
  }
  onChangeUnder() {
    let formTag = <any>this.tags['forms-orders-under'];
    formTag.submit();
    let e = new CustomEvent(PLANNER_SUBMIT_UNDER, {});
    document.dispatchEvent(e);
  }
}
let scope = 'orders.planner.dialog.update-under';
riot.mixin(scope, UpdateUnder as riot.TagMixin);
